export default __webpack_public_path__ + "static/media/features2.7477d2b9.jpg";